import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { BoardEntityTypes } from 'types/Board';
import { boardEntityTypes } from '../../BoardsListHeader/constants/boardEntityTypes';

type RecentBoardsSectionListHeaderProps = {
  boardType: BoardEntityTypes;
  isAdmin: boolean;
};

const RecentBoardsSectionListHeader: FC<RecentBoardsSectionListHeaderProps> = ({
  boardType,
  isAdmin,
}) => {
  const { t } = useTranslate();

  const dateText =
    boardType === boardEntityTypes.COUNCIL ? 'CouncilDate' : 'BoardDate';

  return (
    <thead>
      <tr className="nk-tb-item nk-tb-head">
        <th className="nk-tb-col" />
        <th className="nk-tb-col">
          <h6 className="overline-title mb-05">{t('Name')}</h6>
        </th>
        <th className="nk-tb-col tb-col-sm">
          <h6 className="overline-title mb-05">{t('Status')}</h6>
        </th>
        <th className="nk-tb-col tb-col-md">
          <h6 className="overline-title mb-05">{t(dateText)}</h6>
        </th>
        {isAdmin && (
          <th className="nk-tb-col tb-col-md">
            <h6 className="overline-title mb-05">{t('Visibility')}</h6>
          </th>
        )}
        {isAdmin && <th className="nk-tb-col" />}
      </tr>
    </thead>
  );
};

export default RecentBoardsSectionListHeader;
